<script>
import { mapGetters } from 'vuex';

export default {
  name: 'FAQDataMixin',
  data() {
    return {
      faqs: [],
    }
  },
  computed: {
    ...mapGetters(['activation']),
    hasActivation() {
      return this.activation && this.activation._id;
    },
    activationRegExample() {
      if (!this.hasActivation) {
        return '';
      }
      return this.activation?.registration_example_image?.url;
    },
    hasActivationRegSerial() {
      if (!this.hasActivation) {
        return false;
      }
      return this.activation?.registration_terms_multiple?.some(term => term.serial === true);
    },
    hasActivationRegImei() {
      if (!this.hasActivation) {
        return false;
      }
      return this.activation?.registration_terms_multiple?.some(term => term.imei === true);
    },
    hasActivationRegModel() {
      if (!this.hasActivation) {
        return false;
      }
      return this.activation?.registration_terms_multiple?.some(term => term.modelnr === true);
    }
  },
  mounted() {
    this.faqs = [
      {
        subject: this.transl.HomeFAQ.receiptscan,
        key: 'receiptscan',
        questions: [
          {
            header: this.transl.HomeFAQ.whynotreceipt,
            key: 'whynotreceipt',
            body: [
              {
                faqType: 'list',
                texts: [
                  this.transl.HomeFAQ.whatreceiptscantext1,
                  this.transl.HomeFAQ.notvalidreceipt
                ]
              },
              {
                faqType: 'text-info', text: this.transl.HomeFAQ.includeinreceipt
              },
              {
                faqType: 'list',
                texts: [
                  this.transl.HomeFAQ.receiptscanliststore,
                  this.transl.HomeFAQ.receiptscanlistproduct,
                  this.transl.HomeFAQ.receiptscanlistdate,
                ],
              },
              {
                faqType: 'image', localUrl: `https://www.enginio.io/media/9efa14ea-9258-4e2f-ab36-1734f52b43b7/original.jpeg`, text: this.transl.HomeFAQ.cashierreceipt,
              },
            ],
          },
        ]
      },
      {
        subject: this.transl.UserPV.productregistration,
        key: 'productregistration',
        questions: [
          {
            header: this.transl.HomeFAQ.myproductregistration,
            key: 'myproductregistration',
            body: [
              {
                faqType: 'text-info', text: this.transl.UserPV.includethis
              },
              {
                faqType: 'list',
                texts: this.getActivationRegData(),
              },
              {
                faqType: 'image', localUrl: this.activationRegExample || `https://www.enginio.io/media/95e766f5-7353-420e-8d99-34cc69204a7e/original.png`,
              },
            ],
          },
        ]
      },
      {
        subject: 'Enginio',
        key: 'enginio',
        questions: [
          {
            header: this.transl.HomeFAQ.whatis,
            key: 'whatis',
            body: [
              {
                faqType: 'text-info', text: this.transl.HomeFAQ.whattext1,
              },
              {
                faqType: 'text-info', text: this.transl.HomeFAQ.whattext2,
              },
            ],
          },
          {
            header: this.transl.HomeFAQ.activateheader,
            key: 'activateheader',
            body: [
              {
                faqType: 'text-info', texts: this.transl.HomeFAQ.activatetext1,
              },
              {
                faqType: 'text-info', text: this.transl.HomeFAQ.activatetext2,
              },
            ]
          },
          {
            header: this.transl.HomeFAQ.emailcontribheader,
            key: 'emailcontribheader',
            body: [
              {
                faqType: 'text-info', text: this.transl.HomeFAQ.emailcontribtext1
              },
            ]
          },
          {
            header: this.transl.HomeFAQ.desktopactivateheader,
            key: 'desktopactivateheader',
            body: [
              {
                faqType: 'text-info', text: this.transl.HomeFAQ.desktopactivatetext1,
              },
            ]
          },
          {
            header: this.transl.HomeFAQ.whatactivationheader,
            key: 'whatactivationheader',
            body: [
              {
                faqType: 'text-info', text: this.transl.HomeFAQ.whatactivationtext1,
              },
            ]
          },
        ]
      },
      {
        subject: this.transl.HomeFAQ.account,
        key: 'account',
        questions: [
          {
            header: this.transl.HomeFAQ.pastaccountheader,
            key: 'pastaccountheader',
            body: [
              {
                faqType: 'text-info', text: this.transl.HomeFAQ.pastaccounttext1
              },
            ],
          },
          {
            header: this.transl.HomeFAQ.whyverifybothheader,
            key: 'whyverifybothheader',
            body: [
              {
                faqType: 'text-info', text: this.transl.HomeFAQ.whyverifybothtext1,
              },
              {
                faqType: 'text-info', text: this.transl.HomeFAQ.whyverifybothtext2,
              },
            ],
          },
          {
            header: this.transl.HomeFAQ.severalaccountsdeviceheader,
            key: 'severalaccountsdeviceheader',
            body: [
              {
                faqType: 'text-info', text: this.transl.HomeFAQ.severalaccountsdevicetext1
              },
            ],
          },
          {
            header: this.transl.HomeFAQ.severalnrheader,
            key: 'severalnrheader',
            body: [
              {
                faqType: 'text-info', text: this.transl.HomeFAQ.severalnrtext1
              },
            ],
          },
        ]
      },
      {
        subject: this.transl.HomeFAQ.delivery,
        key: 'delivery',
        questions: [
          {
            header: this.transl.HomeFAQ.whendoigetdigitalheader,
            key: 'whendoigetdigitalheader',
            body: [
              {
                faqType: 'text-info', text: this.transl.HomeFAQ.whendoigetdigitaltext1
              },
            ],
          },
          {
            header: this.transl.HomeFAQ.whendoigetphysicalheader,
            key: 'whendoigetphysicalheader',
            body: [
              {
                faqType: 'text-info', text: this.transl.HomeFAQ.whendoigetphysicaltext1,
              },
              {
                faqType: 'text-info', text: this.transl.HomeFAQ.whendoigetphysicaltext2,
              },
            ],
          },
          {
            header: this.transl.HomeFAQ.timelimitheader,
            key: 'timelimitheader',
            body: [
              {
                faqType: 'text-info', text: this.transl.HomeFAQ.timelimittext1
              },
            ],
          }
        ]
      }
    ];
  },
  methods: {
    getActivationRegData() {
      let regdata = [];
      if (this.hasActivationRegSerial) {
        regdata.push(this.transl.UserPV.serialnumber);
      }
      if (this.hasActivationRegImei) {
        regdata.push(this.transl.UserPV.imei);
      }
      if (this.hasActivationRegModel) {
        regdata.push(this.transl.UserPV.modelnr);
      }
      return regdata;
    }
  }
}
</script>